<template>
    <div class="page white_bg">

        <div style="height: 46px;"><!-- set height if pageHeader is fixed position -->
            <header class="pageHeader white_bg" style="line-height: 30px;">
                <div class="borderLayout paddingH16 paddingV8">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body paddingH16">

            <div class="">

                <div class="messageList">
                    <div class="messageItem paddingV12" v-for="dataItem in dataList" :key="dataItem.id">
                        <div class="color333 bold">{{dataItem.title}}</div>
                        <div class="font12r marginT4" style="line-height: 18px;">
                            {{dataItem.content}}
                        </div>
                        <div class="marginT4">
                            <span class="font12r" style="color:#B8C2D6;">{{formatDate(dataItem.createTime)}}</span>
                            <button class="button viewButton font12r floatR relative" style="top: -10px;"
                                @click="viewItem(dataItem)">立即查看</button>
                        </div>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何消息
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多消息了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>


        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// util
import appHelper from '@/util/appHelper';
import dataMixedUtils from "@util/dataMixedUtils";
import routeHelper from "@util/routeHelper";
import {redirectBySkipType} from '@/components/shixunApp/toDetail'

const config = {
    name : 'meMessageList',
    title : '消息',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/message/list',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            totalPath : 'data.total',
            params : {},
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,

            messageType : '',
        }
    },
    methods : {
        viewItem(dataItem) {

            if (this.messageType == 2)  // 优惠券主题跳转到领取优惠券的页面
            {
                appHelper.redirect(dataItem.skipAddress);
            }
            else if (this.messageType == 3)  // 日常工作展示图文信息
            {
                // 跳转到动态页面
                appHelper.redirect('/me/message/dynamicDetail/' + dataItem.id);
            }
            else    // 系统消息，先判断类型再判断跳转类型
            {
                if (dataItem.skipAddress)
                {
                    appHelper.redirect(dataItem.skipAddress);
                }
                else    // 没有跳转地址则跳转到图文页面
                {
                    appHelper.redirect('/me/message/dynamicDetail/' + dataItem.id);
                }

                // redirectBySkipType(dataItem.skipType, {
                //     skipAddress : dataItem.skipAddress,
                //     skipParams : dataItem.skipParams,
                // });
            }
        }
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(4, (index) => {
                return {
                    id : index,
                    title : '五一活动减满优惠券',
                    content : '您收到一张5元的优惠券，有效期到7月20日到期，尽快去领取并使用哦...',
                    createTime : new Date().getTime()
                }
            })
        }

        this.messageType = routeHelper.getParam(this, 'type');
        if (this.messageType)
        {
            this.apiConfig.list.params.messageType = this.messageType;
        }
        this.loadDataList();
    }
}
</script>

<style lang="scss" scoped>

.grey {
    color: #B8C2D6;
}
.darkgrey {
    color: #5B616C;
}
.messageList {
    .messageItem {
        border-bottom: solid 1px #F6F6F6;
        .viewButton {
            background: #FFBC3B;
            height: 24px;
            line-height: 24px;
            width: auto;
            padding: 0 8px;
            border-radius: 12px;
            color: white;
        }
    }
}
</style>
